/**
 * Sprout's one product version: the iOS and macOS App Store versions, the web app,
 * and the ChatGPT and Claude plugins all carry it. `scripts/check-versions.mjs` fails
 * CI when the Xcode project, the newest App Store metadata, or a plugin disagree.
 */
export const productVersion = "1.1.6";
